import { FunctionComponent } from 'react';

import ArrowLeftIcon from '../Arrow/ArrowLeft.icon';
import { IconPropsInterface } from '../Icon.types';

const ChevronLeftIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <ArrowLeftIcon size={size} color={color} {...rest} />;

ChevronLeftIcon.displayName = 'ChevronLeftIcon';

export default ChevronLeftIcon;
